import { render, staticRenderFns } from "./SmallCategoriesSection.vue?vue&type=template&id=2b7d31b2&scoped=true&"
import script from "./SmallCategoriesSection.vue?vue&type=script&lang=js&"
export * from "./SmallCategoriesSection.vue?vue&type=script&lang=js&"
import style0 from "./SmallCategoriesSection.vue?vue&type=style&index=0&id=2b7d31b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7d31b2",
  null
  
)

export default component.exports